/** @format */
import { MediaQuery } from '@toucan/client/global/application';

import { GridRepeaterProps } from '@toucan/client/shared/components/grid-repeater';

export const getSearchResultsGridColumns =
    (): Required<GridRepeaterProps>['gridColumns'] => {
        return [
            { columns: 4 },
            { mediaQuery: MediaQuery.LARGE_TABLET, columns: 2 },
            { mediaQuery: MediaQuery.SMALL_TABLET, columns: 1 },
            { mediaQuery: MediaQuery.DESKTOP, columns: 3 },
            { mediaQuery: MediaQuery.LARGE_DESKTOP, columns: 4 },
        ];
    };
